module.exports = __webpack_public_path__ + "img/HomeInfo.5ba9d135.png";